import ActionType from 'actions/ActionType'

export default (state = false, action) => {
  switch (action.type) {
    case ActionType.Tasks.ADD_REQUEST:
      return true
    case ActionType.Tasks.UPDATE_REQUEST:
      return true
    case ActionType.Tasks.VALIDATION_FAILURE:
      return false
    case ActionType.Tasks.ADD_FAILURE:
      return false
    case ActionType.Tasks.UPDATE_FAILURE:
      return false
    case ActionType.Tasks.RECEIVE_TASK:
      return false
    default:
      return state
  }
}
